(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/common"), require("@angular/core"), require("@angular/forms"), require("@angular/http"), require("rxjs/Rx"));
	else if(typeof define === 'function' && define.amd)
		define("angular2-font-picker", ["@angular/common", "@angular/core", "@angular/forms", "@angular/http", "rxjs/Rx"], factory);
	else if(typeof exports === 'object')
		exports["angular2-font-picker"] = factory(require("@angular/common"), require("@angular/core"), require("@angular/forms"), require("@angular/http"), require("rxjs/Rx"));
	else
		root["angular2-font-picker"] = factory(root["@angular/common"], root["@angular/core"], root["@angular/forms"], root["@angular/http"], root["rxjs/Rx"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_31__, __WEBPACK_EXTERNAL_MODULE_74__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition